import { getPreLeadEmailLeadFields } from '../services/api/implementation/impl';

/**
 * Pre-leads that arrived from a portal email (99acres, Housing.com …).
 *
 * Email ingestion writes the portal to `prelead.type`, using the EmailLeadPortal
 * enum values. Those are a stored data contract, so they're matched exactly.
 */
export const EMAIL_LEAD_PORTAL_TYPES = [
  '99acres',
  'housing',
  'nobroker',
  'magicbricks',
  'squareyards'
];

export function emailLeadPortal(prelead) {
  const type = String(prelead?.type ?? '')
    .trim()
    .toLowerCase();
  return EMAIL_LEAD_PORTAL_TYPES.includes(type) ? type : null;
}

export function isEmailLeadPrelead(prelead) {
  return emailLeadPortal(prelead) !== null;
}

/**
 * The project an email pre-lead belongs to: the one on the routing rule that
 * filed it.
 *
 * These leads never went through a WhatsApp campaign, so the campaign-project
 * lookup the other pre-leads qualify through finds nothing for them. The rule's
 * project comes back with the pre-lead's email details. Null when the rule has
 * no project, or the details can't be loaded.
 */
export async function fetchEmailLeadProjectId(preLeadId) {
  try {
    const data = await getPreLeadEmailLeadFields(preLeadId);
    const projectId = Number(data?.source?.project_id);
    return Number.isFinite(projectId) && projectId > 0 ? projectId : null;
  } catch {
    return null;
  }
}
